<script lang="ts">
	import { Accordion } from '@atoms';
	import type { AccordionBlock } from './AccordionBlockQuery';

	const { data }: { data: AccordionBlock } = $props();
</script>

<section>
	<div class="container">
		<div class="accordion">
			<Accordion items={data.items} multiple={data.multiple} />
		</div>
	</div>
</section>

<style lang="scss">
	section {
		@include pagePadding;
		@include blockPadding;

		.container {
			border-top: $border;
			@include layoutBlockGrid(false);
			.accordion {
				grid-column: 1 / -1;
				@include md {
					grid-column: 7 / span 6;
				}
			}
		}
	}
</style>
